// bao migrate skip
import * as ko from "knockout";
import { IUniversalField } from "../../interfaces/iuniversal-field";
class RadioButtonsViewModel {
    TagViewModel: IUniversalField = null;
    TagValueModel = null;
    TagId: string = null;
    Parent: any = null;
    constructor(shiftReportTagTab, tagId) {
        this.TagId = tagId;
        this.Parent = shiftReportTagTab;
        this.TagViewModel = this.Parent.getTagModel(this.TagId);
        this.TagValueModel = this.Parent.getTagObservable(this.TagId);
        // prüfen ob mandatory, wenn ja und noch kein Wert gesetzt ...
        if (ko.unwrap(ko.unwrap(this.TagViewModel).IsMandatory)) {
            if ((this.TagValueModel.TextValue() == "" || this.TagValueModel.TextValue() === null) && this.TagViewModel.Options && this.TagViewModel.Options.length > 0) {
                // ... setzte ersten Wert als default (ohne dass dirtyflag anspringt)
                this.Parent.TabPage.DirtyFlag.pause();
                this.TagValueModel.TextValue(this.TagViewModel.Options[0]);
                this.Parent.TabPage.DirtyFlag.resume();
            }
        }
    }
    init() {
    }
}
export default RadioButtonsViewModel;